import Alert, { type AlertColor, type AlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Snackbar from '@mui/material/Snackbar';
import type { ReactElement } from 'react';

const DEFAULT_AUTO_HIDE_MS = 5000;

export type FeedbackSnackbarProps = {
    open: boolean;
    message: string;
    severity: AlertColor;
    onClose: () => void;
    title?: string;
    variant?: AlertProps['variant'];
    autoHideDuration?: number;
};

export function FeedbackSnackbar({
    open,
    message,
    severity,
    onClose,
    title,
    variant = 'filled',
    autoHideDuration = DEFAULT_AUTO_HIDE_MS,
}: FeedbackSnackbarProps): ReactElement {
    return (
        <Snackbar
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={onClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert severity={severity} variant={variant} onClose={onClose} sx={{ width: '100%' }}>
                {title ? <AlertTitle>{title}</AlertTitle> : null}
                {message}
            </Alert>
        </Snackbar>
    );
}
